define('app/views/login_links_view',['app/setup'], function(takhfifan) {

  takhfifan.LoginLinksView = Backbone.View.extend({

    events: {
      'click .tkh-login-toggle': 'toggleLoginForm'
    },

    initialize: function() {
      this.allowGuest = this.$el.data('allowGuest');
      if(!this.allowGuest){
        this.$el.show();
      }
      takhfifan.eventHub.on('customer:login', function(data) {
        this.$el.hide();
      }, this);
    },

    toggleLoginForm: function(event) {
      takhfifan.eventHub.trigger('customer:loginForm');
    }

  });

});

